export const data1 = [
    {
        productId: 14692429627759,
        variantId: 51841040286063,
        pc: 'https://websiteoss.ecoflow.com/upload/image/1747898959846/35.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1747899018983/35-pad.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1747898959846/35.jpg',
    },
    {
        productId: 14691364143471,
        variantId: 51836010660207,
        pc: 'https://websiteoss.ecoflow.com/upload/image/1747899056061/45.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1747899054749/45-pad.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1747899056061/45.jpg',
    },
    {
        productId: 14711356686703,
        variantId: 51960249811311,
        pc: 'https://websiteoss.ecoflow.com/upload/image/1747899054937/55.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1747899056288/55-pad.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1747899054937/55.jpg',
    },
];

export const data2 = [
    {
        productId: 14711366844783,
        variantId: 51960365613423,
        pc: 'https://websiteoss.ecoflow.com/upload/image/1747899055094/D3b.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1747899055280/D3b-pad.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1747899055094/D3b.jpg',
    },
    {
        productId: 14711369040239,
        variantId: 51960385798511,
        pc: 'https://websiteoss.ecoflow.com/upload/image/1747899055469/D3.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1747899055870/D3-pad.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1747899055469/D3.jpg',
    },
    {
        productId: 14711364419951,
        variantId: 51960339988847,
        pc: 'https://websiteoss.ecoflow.com/upload/image/1747899056474/D2M.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1747899055674/D2M-pad.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1747899056474/D2M.jpg',
    },
];
